import React, { useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { FaSortAmountDown, FaSortAmountUp } from 'react-icons/fa';
import './styles.css';


import FeedLayout from '../Includes/FeedLayout';
import api from '../../services/api';

import went_down from '../../assests/went_down.png';
import went_up from '../../assests/went_up.png';
import didnt_move from '../../assests/didnt_move.png';
import { useTranslation } from 'react-i18next';
import NomeFrigorifico from './NomeFrigorifico';

export default function Ranking() {

  const [posts, setPosts] = useState([]);
  const [page, setPage] = useState(1);
  const [reverse, setReverse] = useState(true);

  const name = sessionStorage.getItem('name');
  const USER_EMAIL = sessionStorage.getItem('email');
  const USER_TOKEN = sessionStorage.getItem('token');
  const history = useHistory();
  const { t } = useTranslation();

  useEffect(() => {
    api.get("/v5/fridges/optimized_ranking", {
      headers: {
        'USER_EMAIL': USER_EMAIL,
        'USER_TOKEN': USER_TOKEN,
        'PARAMS': '',
        'Content-Type': 'application/json'
      }
    }).then(response => {
      setPosts(response.data);
      console.log(response.data);
    }).catch(error => {
      history.push('/');
    });
  }, [USER_EMAIL, USER_TOKEN, history])

  const vEstados = {
    12: t('commons.states.acre'),
    16: t('commons.states.amapa'),
    13: t('commons.states.amazonas'),
    14: t('commons.states.roraima'),
    11: t('commons.states.rondonia'),
    15: t('commons.states.para'),
    17: t('commons.states.tocantins'),
    27: t('commons.states.alagoas'),
    29: t('commons.states.bahia'),
    23: t('commons.states.ceara'),
    21: t('commons.states.maranhao'),
    22: t('commons.states.piaui'),
    25: t('commons.states.paraiba'),
    26: t('commons.states.pernanbuco'),
    24: t('commons.states.rioGrandeDoNorte'),
    28: t('commons.states.sergipe'),
    32: t('commons.states.espiritoSanto'),
    31: t('commons.states.minasGerais'),
    33: t('commons.states.rioDeJaneiro'),
    35: t('commons.states.saoPaulo'),
    41: t('commons.states.parana'),
    42: t('commons.states.santaCatarina'),
    43: t('commons.states.rioGrandeDoSul'),
    53: t('commons.states.distritoFederal'),
    52: t('commons.states.goias'),
    51: t('commons.states.matoGrosso'),
    50: t('commons.states.matoGrossodoSul'),
    PY: t('commons.states.paraguai'),
    'PY-ASU': t('commons.states.paraguai')
  };

  function nomeEstado(post) {
    const mapped = vEstados[post.state_code];
    if (mapped) {
      return mapped;
    }
    if (post.state_name) {
      return post.state_name;
    }
    const amostra = (Array.isArray(post.fridges) ? post.fridges : [])
      .map((frig) => frig.name || '')
      .join(' ');
    if (/Paragu|\bPY\b|PY-|Asunci[oó]n|Assuncion/i.test(amostra)) {
      return t('commons.states.paraguai');
    }
    return '';
  }
  const imgSwitch = (img) => {
    switch (img) {
      case ("went_down"):
        return <img src={went_down} alt={t('pages.ranking.alt.up')} />
      case ("went_up"):
        return <img src={went_up} alt={t('pages.ranking.alt.down')} />
      default:
        return <img src={didnt_move} alt={t('pages.ranking.alt.keep')} />
    }
  }

  const corLinhaNome = (numero) => {
    if (numero % 2 === 0) {
      return "nome cinza";
    } else {
      return "nome";
    }
  }
  const corLinhaNota = (numero) => {
    if (numero % 2 === 0) {
      return "nota cinza";
    } else {
      return "nota";
    }
  }
  const corLinhaBotao = (numero) => {
    if (numero % 2 === 0) {
      return "botao cinza";
    } else {
      return "botao";
    }
  }
  function ordenar() {
    setReverse((atual) => !atual);
  }

  function Frigorifico(props) {
    const frig = Array.isArray(props.vet) ? props.vet.slice() : [];
    frig.sort((a, b) => {
      const notaA = parseFloat(a.evaluation_average) || 0;
      const notaB = parseFloat(b.evaluation_average) || 0;
      return reverse ? notaB - notaA : notaA - notaB;
    });

    return (
      <>
        {frig.map((el, index) => (
          <React.Fragment key={el.id || `${el.name}-${index}`}>
            <div className={corLinhaNome(index)}>
              <Link to={'/rankingdetalhe/' + el.id}><NomeFrigorifico name={el.name} /></Link>
            </div>
            <div className={corLinhaNota(index)}>
              {Intl.NumberFormat('pt-br', { style: 'decimal', minimumFractionDigits: 1, maximumFractionDigits: 1 }).format(el.evaluation_average)}
            </div>
            <div className={corLinhaBotao(index)}>
              <Link to={'/rankingdetalhe/' + el.id}>{imgSwitch(el.current_position)}</Link>
            </div>
          </React.Fragment>
        ))}
      </>
    );
  }

  return (
    <FeedLayout active="ranking">
    <div className="ranking-container">
      <div className="pagTitulo">
        <h1> {t('pages.ranking.title')} </h1>
      </div>
      <section className="body">
        <div className="clIcone">
          <button
            type="button"
            className={reverse ? 'is-desc' : 'is-asc'}
            onClick={ordenar}
            title={reverse ? t('pages.ranking.sortDesc') : t('pages.ranking.sortAsc')}
            aria-label={reverse ? t('pages.ranking.sortDesc') : t('pages.ranking.sortAsc')}
          >
            {reverse ? <FaSortAmountDown /> : <FaSortAmountUp />}
          </button>
        </div>
        <ul>

          {
            posts.map(post => (
              <li key={post.state_code}>
                <div className="estado">
                  <h2 >{nomeEstado(post)}</h2>
                </div>
                <div className="nome"><strong> {t('pages.ranking.name')} </strong></div>
                <div className="nota"><strong> {t('pages.ranking.note')} </strong></div>
                <div className="botao"></div>
                <Frigorifico vet={post.fridges} />
              </li>
            ))}
        </ul>
      </section>
    </div>
    </FeedLayout>
  );
}
